import axios from 'axios'

import { showMessage } from '@/store/messages'

const instance = axios.create({
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error

    if (!axios.isCancel(error)) {
      const code = response ? +response.status : null
      const type = !!code && code < 500 ? 'warning' : 'error'
      const message = response && response.data ? response.data.message : null

      showMessage(code ? (message ? message : response.statusText) : 'Нет подключения к Интернету', type)
    }

    throw error
  },
)

instance.interceptors.request.use((config) => {
  config.url = `/index.php?action=${config.url}`

  return config
})

export default instance
